import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import api, { formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function RecoverAccount() {
  const [params] = useSearchParams();
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const recover = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/account/recover-token", { token: params.get("token") || "" });
      setSession(data);
      nav("/", { replace: true });
    } catch (e) { setErr(formatErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-mesh flex items-center justify-center p-4" data-testid="recover-account-page">
      <div className="w-full max-w-md glass rounded-3xl p-6 text-center">
        <ShieldCheck className="w-12 h-12 mx-auto text-[#FFD700] mb-3"/>
        <h1 className="font-outfit font-extrabold text-2xl mb-2">Recover your Hifireels account</h1>
        <p className="text-sm text-white/70 mb-5">Your data is safe. Tap below to restore your account, reels and wallet.</p>
        {err && <p className="text-sm text-[#FF2A5F] mb-3" data-testid="recover-error">{err}</p>}
        <button onClick={recover} disabled={busy} data-testid="recover-submit"
          className="w-full py-3 rounded-full bg-[#FFD700] text-black font-extrabold disabled:opacity-50 flex items-center justify-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin"/>}Recover my account
        </button>
        <Link to="/login" className="block mt-4 text-sm text-white/60">Back to login</Link>
      </div>
    </div>
  );
}
